import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Grid, Card, CardContent, useTheme, CircularProgress, Button, Chip, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { apiService } from '../services/api';
import WorkIcon from '@mui/icons-material/Work';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ScheduleIcon from '@mui/icons-material/Schedule';

const Careers = () => {
  const theme = useTheme();
  const [data, setData] = useState({ careers: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiService.getCareers().then(setData).finally(() => setLoading(false));
  }, []);

  const careers = data.careers || [];

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', py: 8, background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)' }}>
      <Container maxWidth="lg">
        <Typography variant="h2" textAlign="center" gutterBottom sx={{ color: theme.palette.primary.main, fontWeight: 700, mb: 2 }}>
          Careers
        </Typography>
        <Typography variant="h6" textAlign="center" sx={{ mb: 6, color: 'text.secondary', maxWidth: 640, mx: 'auto', lineHeight: 1.65 }}>
          Build products that NGOs and SMEs actually use. No open role? Send your CV anyway — we hire when we find the
          right fit.
        </Typography>

        {careers.length === 0 ? (
          <Box textAlign="center" sx={{ py: 8 }}>
            <WorkIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
            <Typography variant="h6" color="text.secondary" gutterBottom>No open positions right now</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>Check back later or send us your CV—we’d love to hear from you.</Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center" alignItems="center">
              <Button component={Link} to="/contact" variant="contained" color="secondary" sx={{ fontWeight: 700 }}>
                Send your CV
              </Button>
              <Button component={Link} to="/request-quote" variant="outlined" color="primary" sx={{ fontWeight: 700 }}>
                I need a product built
              </Button>
            </Stack>
          </Box>
        ) : (
          <Grid container spacing={3}>
            {careers.map((job, i) => (
              <Grid item xs={12} md={6} key={job.id}>
                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}>
                  <Card sx={{ height: '100%', borderLeft: '4px solid', borderLeftColor: theme.palette.secondary.main }}>
                    <CardContent>
                      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
                        {job.title}
                      </Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                        {job.location && <Chip size="small" icon={<LocationOnIcon />} label={job.location} />}
                        {job.job_type && <Chip size="small" icon={<ScheduleIcon />} label={job.job_type} />}
                        {job.department && <Chip size="small" label={job.department} />}
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{job.description || ''}</Typography>
                      <Button component={Link} to="/contact" variant="outlined" color="primary" size="small">
                        Apply
                      </Button>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Box>
  );
};

export default Careers;
